import type { ComponentType, PropsWithChildren } from 'react';

import { Focusable, Tooltip, TooltipTrigger } from '@iconik-io/uad';

export type StatusTooltipProps = PropsWithChildren<{ label: string }>;

export type StatusTooltipComponent = ComponentType<StatusTooltipProps>;

export function StatusTooltip({ label, children }: StatusTooltipProps) {
  return (
    <TooltipTrigger>
      <Focusable excludeFromTabOrder>
        <div role="status" aria-label={label}>
          {children}
        </div>
      </Focusable>
      <Tooltip placement="bottom">{label}</Tooltip>
    </TooltipTrigger>
  );
}
